module.exports = __webpack_public_path__ + "img/cosmos-light.9cafba08.svg";